import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_Content_Routes: Routes = [
  {
    path: 'customer-portal',
    loadChildren: () =>
      import('../../gigatel-customer-portal/gigatel-customer-portal.module').then(
        (m) => m.GigatelCustomerPortalModule
      ),
  },
  {
    path: 'icon',
    loadChildren: () =>
      import('../../components/icon/icon.module').then((m) => m.IconModule),
  },
  {
    path: 'elements',
    loadChildren: () =>
      import('../../components/elements/elements.module').then(
        (m) => m.ElementsModule
      ),
  },
  {
    path: 'advanced',
    loadChildren: () =>
      import('../../components/advanced-ui/advanced-ui.module').then(
        (m) => m.AdvancedUiModule
      ),
  },

  {
    path: 'maps',
    loadChildren: () =>
      import('../../components/maps/maps.module').then((m) => m.MapsModule),
  },
  {
    path: 'utilities',
    loadChildren: () =>
      import('../../components/utilities/utilities.module').then(
        (m) => m.UtilitiesModule
      ),
  },
];
